import { render, staticRenderFns } from "./MenuItemsList.vue?vue&type=template&id=647d97c4"
import script from "./MenuItemsList.vue?vue&type=script&lang=js"
export * from "./MenuItemsList.vue?vue&type=script&lang=js"
import style0 from "./MenuItemsList.vue?vue&type=style&index=0&id=647d97c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports